<template>
  <div v-if="item.key === 'tags'">
    <v-list-item
    v-for="(tag, index) in tagsAsMenus"
    :key="index"
    link
    data-testid="contacts-drawer-tagslist"
    :class="$vuetify.theme.dark ? 'custom-list-item-dark' : 'custom-list-item-light'"
    @click="onDrawerItemClick(tag)"
    >
    <v-list-item-icon v-if="tag.icon" class="mt-4">
      <v-badge
        color="grey"
        offset-x="7"
        offset-y="7"
        :content="tags[index].inUseCount == 0 ? '0' : tags[index].inUseCount"
      >
      <v-icon>{{ tag.icon }}</v-icon>
      </v-badge>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
      {{ tag.text }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="d-inline ml-2">
      <div v-if="canContactsWrite">
        <v-btn
          icon
          class="edit_tag_btn"
          @click="openTagForm({tag: tags[index], isPersonal: false, isUpdate: true})"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          class="delete_tag_btn"
          @click="openTagDeleteForm({tag: tags[index]})"
        >
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-list-item-action>
    </v-list-item>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Tag from 'Store/class/contact/tag'
import PersonalTag from 'Store/class/contact/personal_tag'
export default {
  name: 'contacts-drawer',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      canContactsWrite: 'permissions/contactsWrite',
      canContactsManagePersonal: 'permissions/contactsManagePersonal',
      getIsPersonal: 'contacts/isPersonal',
      tags: 'contacts/tags/tags',
      personalTags: 'contacts/personalTags/personalTags',
      getFilterByTags: 'contacts/filterByTags',
      getFilterByPersonalTags: 'contacts/filterByPersonalTags'
    }),
    tagsAsMenus () {
      const menus = []
      if (this.tags) {
        this.tags.forEach(tag => {
          menus.push({ icon: 'mdi-label-outline', text: tag.name, id: tag.id, key: 'tag_item' })
        })
      }
      return menus
    },
    filterByPersonal: { get () { return this.getIsPersonal }, set (isPersonal) { this.setIsPersonal(isPersonal) } },
    filterByTags: { get () { return this.getFilterByTags }, set (filterByTags) { this.setFilterByTags(filterByTags) } },
    filterByPersonalTags: { get () { return this.getFilterByPersonalTags }, set (filterByPersonalTags) { this.setFilterByPersonalTags(filterByPersonalTags) } }
  },
  methods: {
    ...mapActions({
      setIsPersonal: 'contacts/setIsPersonal',
      getContacts: 'contacts/get',
      getTags: 'contacts/tags/get',
      getPersonalTags: 'contacts/personalTags/get',
      openTagDialog: 'contacts/tagForm/open',
      openDeleteDialog: 'contacts/tagDeleteForm/open',
      openContactForm: 'contacts/form/open',
      setFilterByTags: 'contacts/setFilterByTags',
      setFilterByPersonalTags: 'contacts/setFilterByPersonalTags',
      openImportDialog: 'contacts/importForm/open'
    }),

    openTagForm (params) {
      const isPersonal = params.isPersonal
      const isUpdate = params.isUpdate
      let tag = null
      if (isUpdate) {
        tag = params.tag
      } else {
        tag = isPersonal ? new PersonalTag({ id: null, name: '' }) : new Tag({ id: null, name: '' })
      }
      this.openTagDialog({ tag, isPersonal, isUpdate })
    },

    openTagDeleteForm (params) {
      const tag = params.tag
      this.openDeleteDialog(tag)
    },

    onDrawerItemClick (item) {
      switch (item.key) {
        case 'tag_item':
          this.filterByPersonal = false
          this.filterByTags = [item.id]
          this.filterByPersonalTags = []
          break
      }
    }
  }
}
</script>

<style>
.custom-list-item-dark {
  background-color: #424242;
}
.custom-list-item-light {
  background-color: #F5F5F5;
}
</style>
